export interface Standort {
  wegpunkt: Wegpunkt
  ort: Ort
  gleisart: Gleisart | null // ausgefüllt wenn ort = 'STRECKE'
  von: string | null // ausgefüllt wenn ort = 'STRECKE'
  nach: string | null // ausgefüllt wenn ort = 'STRECKE'
  gleis: string | null // ausgefüllt wenn ort = 'BAHNHOF'
  betriebsstelle: string | null // ausgefüllt wenn ort = 'BAHNHOF'
  kilometrierung: string | null // ausgefüllt wenn wegpunkt = 'KILOMETRIERUNG'
  weiche: string | null // ausgefüllt wenn wegpunkt = 'WEICHE'
  signal: string | null // ausgefüllt wenn wegpunkt = 'SIGNAL'
}

export enum Wegpunkt {
  Kilometrierung = 'KILOMETRIERUNG',
  Signal = 'SIGNAL',
  Weiche = 'WEICHE'
}

export enum Ort {
  Strecke = 'STRECKE',
  Bahnhof = 'BAHNHOF'
}

export enum Gleisart {
  Regelgleis = 'REGELGLEIS',
  Gegengleis = 'GEGENGLEIS',
  Gleis = 'GLEIS'
}
